import React, { useState, useEffect } from "react";
import { Outlet } from "react-router-dom";

import HeaderAdmin from '../../components/headerAdmin/headerAdmin';
import FooterApp from '../../components/footerApp/footerApp';
import SideMenuAdmin from '../../components/sideMenuAdmin/sideMenuAdmin';
import { getFromLocalStorage } from "../../helpers/EncryptData";
import './AdminView.css';
import { Layout } from "antd";
import { saveToLocalStorage } from "../../helpers/EncryptData";
const { Sider, Content } = Layout;

const AdminView = () => {

    const [isAdmin, setIsAdmin] = useState(false);
    const [isSuperAdmin, setIsSuperAdmin] = useState(true);
    const [showOrganizationMenu, setShowOrganizationMenu] = useState(false);

    useEffect(() => {
        const current_org = getFromLocalStorage("current_org");
        const is_superuser = localStorage.getItem("is_superuser");
        const is_staff = localStorage.getItem("is_staff");
        setIsSuperAdmin(is_superuser === 'true' || is_superuser === true);
        setIsAdmin(is_staff === 'true' || is_staff === true);
        if (current_org) {
            setShowOrganizationMenu(true);
        }
    }, [])

    const setOrganizationValuesToSee = (org_data) => {
        if (showOrganizationMenu) {
            setShowOrganizationMenu(false);
        }

        saveToLocalStorage("current_org", {
            org_id: org_data.org_id,
            org_name: org_data.org_name
        });

        window.location.reload(); // Esto es suficiente
    };
    return (
        <Layout style={{ minHeight: "100vh", backgroundColor: "lightgrey" }}>
            <Layout>
                {/* Menú lateral */}
                <Sider className="sider-container" width={250} style={{ backgroundColor: "white", display: "flex", flexDirection: "column", justifyContent: "space-between", minHeight: "100vh" }}>
                    <div className="sider-container" style={{ flex: 1, display: "flex", flexDirection: "column" }}>
                        <img 
                            src='/talentha-color.png' 
                            alt='Logo Talentha' 
                            style={{
                                height: "100px",
                                maxWidth: "230px",
                                width: "auto",
                                objectFit: "contain"
                            }} 
                        />
                        <div style={{ flex: 1}}>
                            <SideMenuAdmin showOrganizationMenu={showOrganizationMenu} isSuperAdmin={isSuperAdmin} isAdmin={isAdmin}/>
                        </div>
                    </div>
                    <FooterApp />
                </Sider>
                {/* Panel derecho (contenido dinámico) */}
                <Layout style={{ height: "100vh" }}>
                    <HeaderAdmin />
                    <Content style={{ height: "100vh" , background: "#E0E0E0", overflowY: "auto" }}>
                        <Outlet context={{ setOrganizationValuesToSee }} /> {/* Aquí se renderizan las vistas */}
                    </Content>

                    {/* Footer */}
                </Layout>
            </Layout>
        </Layout>
    );
};

export default AdminView;
